import React, { memo, useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import CountdownTimer, {
  remaining_time,
} from "components/FullTest/CountdownTimer";
import TestProgress from "components/FullTest/MockOperations/TestProgress";
import QuestionInstruction from "components/FullTest/MockOperations/QuestionInstruction";
import Question from "components/FullTest/Question";
import NextModal from "components/FullTest/MockOperations/Popup/NextModal";
import WaitQuestionAudioFinish from "components/FullTest/MockOperations/Popup/WaitQuestionAudioFinish";
import SubmitSectionModal from "components/FullTest/MockOperations/Popup/SubmitSectionModal";
import SaveAndExitPopup from "components/FullTest/MockOperations/Popup/SaveAndExitPopup";
import TimeoutPopup from "components/FullTest/MockOperations/Popup/TimeoutPopup";

import {
  processDataToSubmit,
  questionTime,
  time_spent,
} from "components/FullTest/MockOperations/SubmitData";
import {
  submitMockQuestionApi,
  saveAndExitApi,
  sectionTimeOutApi,
} from "components/FullTest/ApiCalls";

const NEXT = 1;
const SUBMIT = 2;
const SAVE_AND_EXIT = 3;
const AUDIO_QUESTIONS = [2, 4, 5, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];

const Questions = memo(function Questions({
  mockData,
  mock,
  time,
  questions,
  setSection,
  pending,
  skip,
  currQ,
}) {
  // const [currentQuestion, setCurrentQuestion] = useState(
  //   currQ === 0 ? currQ : mockData.curr_q
  // );
  const [currentQuestion, setCurrentQuestion] = useState(
    pending == 1 ? 0 : mockData.curr_q
  );
  const [timeUp, setTimeUp] = useState(false);
  const [nextModal, setNextModal] = useState(false);
  const [questionAudioFinished, setQuestionAudioFinished] = useState(false);
  const [questionAudioModal, setQuestionAudioModal] = useState(false);
  const [submitSection, setSubmitSection] = useState(false);
  const [saveAndExitModal, setSaveAndExitModal] = useState(false);
  const [userResponse, setUserResponse] = useState(false);
  const [strategy, setStrategy] = useState(1);
  const [reduceSectionTime, setReduceSectionTime] = useState(0);
  const [sectionTime, setSectionTime] = useState(0);
  // console.log(mockData, mockData.curr_q, "mockData.curr_q");
  // console.log(
  //   mockData,
  //   mock,
  //   time,
  //   questions,
  //   setSection,
  //   pending,
  //   "pending",
  //   skip,
  //   currQ,
  //   "We are in Questions where Current Question is set to currQ or mockData.curr_q"
  // );

  useEffect(() => {
    // track time (in seconds) spent on a question.
    questionTime();
  }, [currentQuestion]);

  const submit = (response) => {};

  const showResult = () => {};

  // receive data from subcategory files.
  const nextQuestion = async (response) => {
    setUserResponse(false);

    switch (response.data) {
      case "":
        response.data = new Blob(["hello worllllllllllllld"]);
        break;
      case undefined:
        response.data = new Blob(["hello worlppppppppppppd"]);
        break;
      default:
      // do nothing.
    }

    // check if the question is final question of section.
    // if final. submit the section.
    let submit_section = false;
    let rem_time = parseInt(remaining_time);
    let test_pending = 0;
    if (currentQuestion + 1 === questions.length || timeUp) {
      submit_section = true;
      rem_time = nextSectionRemainingTime() * 60; // in seconds. already converting to minutes in backend.

      // if current section is less than listening then mark pending 1.
      // if current section is listening and its timeout then mark pending 0.
      test_pending = skip > 2 ? 0 : 1;
    } else {
      submit_section = updateSubmitSection();
    }

    const prepared_data = processDataToSubmit(
      response,
      strategy,
      questions[currentQuestion],
      mock.question.length,
      mock.id,
      time_spent,
      rem_time,
      skip,
      submit_section,
      // currentQuestion,
      pending ? mockData.curr_q + currentQuestion : currentQuestion,
      test_pending
    );

    if (prepared_data) {
      // reduce time from main timer.
      if ([6, 7, 13].includes(questions[currentQuestion].subcategory_id)) {
        setReduceSectionTime(response.time);
      }

      if (!timeUp) {
        // agar time up nahi hua hai to section ya currect Question yaha se change hoga.
        // otherwise Timout popup ke OK button ko click krke.
        if (submit_section) {
          setSection((prev) => prev + 1);
        } else {
          setCurrentQuestion((prev) => prev + 1); // show next Question.
        }
      } else if (timeUp && skip === 3) {
        // listening section timeout.
        setSection(10);
      }

      const res = await submitMockQuestionApi(prepared_data);
    }
  };

  const updateSubmitSection = () => {
    return timeUp ? true : false;
  };

  const testPendingValue = () => {
    return timeUp ? 1 : 0;
  };

  // open a confirmation popup.
  const next = (type) => {
    setNextModal(false);
    switch (type) {
      case NEXT:
        submitAndNextQuestion();
        break;
      case SUBMIT:
        submitAndNextSection();
        break;
      case SAVE_AND_EXIT:
        saveAndExit();
        break;
      default:
      // do nothing
    }
  };

  const soundChecked = () => {
    setQuestionAudioFinished(true);
  };

  const submitResponse = () => {
    // userResponse = true. which will return user response data from related file.
    setUserResponse(true);
    setQuestionAudioFinished(false);
  };

  const submitAndNextQuestion = () => {
    if (
      AUDIO_QUESTIONS.includes(questions[currentQuestion].subcategory_id) &&
      !questionAudioFinished
    ) {
      // wait question audio to finish.
      setQuestionAudioModal(true);
    } else {
      setNextModal(true);

      // set Question Audio Finished = false
      // setQuestionAudioFinished(false);
    }
  };

  const submitAndNextSection = () => {
    if (
      AUDIO_QUESTIONS.includes(questions[currentQuestion].subcategory_id) &&
      !questionAudioFinished
    ) {
      // wait question audio to finish.
      setQuestionAudioModal(true);
    } else {
      setSubmitSection(true);
    }
  };

  const saveAndExit = () => {
    setSaveAndExitModal(true);
  };

  // save & exit final action.
  const saveTestAndExit = () => {
    const question = questions[currentQuestion];

    let bodyFormData = new FormData();
    bodyFormData.append("q_count", mock.question.length);
    bodyFormData.append("mock_id", mock.id);
    bodyFormData.append("q_time", time_spent);
    bodyFormData.append("complete", 0);
    bodyFormData.append("question_number", question.question_number);
    bodyFormData.append("pending", 1);
    // bodyFormData.append("curr_q", currentQuestion);
    const globalCurrentQuestion = pending
      ? mockData.curr_q + currentQuestion
      : currentQuestion;
    bodyFormData.append("curr_q", globalCurrentQuestion);
    bodyFormData.append("time", remaining_time);

    saveAndExitApi(bodyFormData);

    // // section 6 is for screen which we are showing when user clicks on Save & Exit button.
    setSection(6);
  };

  // at the end of section. store next section's time.
  const nextSectionRemainingTime = () => {
    let time = 0;
    switch (skip) {
      case 1:
        // at the end of speaking section. assign reading section time.
        time = parseInt(mockData.mock.reading_time); // in minutes
        break;
      case 2:
        // at the end of reading section. assign listening section time.
        time = parseInt(mockData.mock.listening_time); // in minutes
        break;
      default:
      // do nothing. we don't need to set time after listening section. Test Finished.
    }
    setSectionTime(time); // in minutes
    return time;
  };

  const sectionTimedOut = () => {
    // 1
    const ids = questions.slice(currentQuestion);

    const bodyFormData = new FormData();
    bodyFormData.append("mock_id", mockData.mock.id);
    bodyFormData.append("time", nextSectionRemainingTime());
    ids.map((v, k) => {
      if (k !== 0) {
        bodyFormData.append("id[]", `${v.id}-${v.question_number}`);
      }
    });
    bodyFormData.append("skip", skip);

    // unattempted api.
    sectionTimeOutApi(bodyFormData);

    // 2
    setTimeUp(true);
    submitResponse(); // will fetch user response to this file.
  };

  const endCurrentSectionAndStartNext = () => {
    // only close popup and move control to next section.
    setSection((prev) => prev + 1);
  };

  const props_data = {
    submit,
    showResult,
    soundChecked,
    nextQuestion,
    setStrategy,
    data: questions[currentQuestion],
    resultMode: false,
    testMode: true,
    stopRecording: userResponse,
    strategy,
  };

  // console.log(questions, "questions");
  // console.log(questions[currentQuestion], "currentQuestion");
  // console.log(currentQuestion, "currentQuestion index");

  return (
    <>
      <div className="content questionsArea">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={6}>
                    <CardTitle tag="h4">{mock.title}</CardTitle>
                  </Col>
                  <Col xs={6}>
                    <div className="text-right questionTime">
                      <CountdownTimer
                        time={time}
                        sectionTimedOut={sectionTimedOut}
                        reduceSectionTime={reduceSectionTime}
                        setReduceSectionTime={setReduceSectionTime}
                      />

                      <TestProgress
                        mockData={mockData}
                        questions={questions}
                        currentQuestion={currentQuestion}
                        pending={pending}
                      />
                    </div>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                <QuestionInstruction
                  subcategoryId={questions[currentQuestion]?.subcategory_id}
                  qTitle={questions[currentQuestion]?.q_title}
                />

                <Question
                  question={questions[currentQuestion]}
                  props_data={props_data}
                  key={currentQuestion}
                />
              </CardBody>
            </Card>
          </Col>

          <Col xs={12}>
            <div className="bottomBtns">
              <Row>
                <Col xs={9}>
                  {currentQuestion < questions.length - 1 && questions[currentQuestion].question_number !== 1 && (
                    <Button
                      color="primary"
                      onClick={(e) => next(SAVE_AND_EXIT)}
                      size="xs"
                    >
                      Save & Exit
                    </Button>
                  )}

                  {/*{dashboardFlag &&
										<NavLink to={'/admin/dashboard'} >
											<Button
												color="primary"
												size="xs"
											>Go to Dashboard</Button>
										</NavLink>
									}*/}
                </Col>

                <Col xs={3}>
                  {currentQuestion < questions.length - 1 ? (
                    <Button
                      color="primary"
                      onClick={(e) => next(NEXT)}
                      size="xs"
                    >
                      NEXT
                    </Button>
                  ) : (
                    <Button
                      color="primary"
                      onClick={(e) => next(SUBMIT)}
                      size="xs"
                    >
                      Submit
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>

      <NextModal
        isOpen={nextModal}
        handler={setNextModal}
        submitResponse={submitResponse}
      />

      <WaitQuestionAudioFinish
        isOpen={questionAudioModal}
        handler={setQuestionAudioModal}
      />

      <SubmitSectionModal
        isOpen={submitSection}
        handler={setSubmitSection}
        submitResponse={submitResponse}
      />

      <SaveAndExitPopup
        isOpen={saveAndExitModal}
        handler={setSaveAndExitModal}
        saveTestAndExit={saveTestAndExit}
      />

      <TimeoutPopup
        isOpen={timeUp && skip < 3 ? true : false}
        endCurrentSectionAndStartNext={endCurrentSectionAndStartNext}
      />
    </>
  );
});

export default Questions;
